module.exports = eval("try{require('fs')}catch(e){}");